import React, { useContext } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import $ from "jquery";
import { BasicContext } from "../App";

const NoMatch = () => {
    const { t } = useTranslation();
    const { setLoading } = useContext(BasicContext);

    setTimeout(() => {
        $("#noMatch").css("min-height", `${window.innerHeight - $("#footerMain").outerHeight()}px`);
        $("#loadingView").fadeOut(500);
        setTimeout(() => {
            setLoading(false);
        }, 600);
    }, 1000);

    return (
        <Container id="noMatch" fluid className="h-100">
            <Row>
                <Col xs={12} lg={{ span: 8, offset: 2 }} xl={{ span: 6, offset: 3 }} className="text-center">
                    <p className="mt-5 mb-3 fs-1 text-bold">404</p>
                    <p className="fs-4 pb-4">{t("noMatch")}</p>
                    <Button size="lg" variant="primary" as={Link} to={"/"}>
                        {t("goBackToMainPage")}
                    </Button>
                </Col>
            </Row>
        </Container>
    );
};

export default NoMatch;
